import { create } from "zustand";
import { persist } from "zustand/middleware";

interface SettingsStore {
  animationSpeed: "normal" | "reduced" | "none";
  fontSize: "small" | "medium" | "large";
  defaultFeedbackView: "timeline" | "swimlane" | "compact";
  notifyOnRunComplete: boolean;
  notifyOnError: boolean;
  notifyOnInputRequest: boolean;
  sidebarCollapsed: boolean;
  rightPanelCollapsed: boolean;
  feedbackPanelCollapsed: boolean;
  forceLayoutMode: "auto" | "standard" | "wide" | "ultra-wide" | "vertical";

  setSetting: <K extends keyof SettingsStore>(key: K, value: SettingsStore[K]) => void;
  toggleSidebar: () => void;
  toggleRightPanel: () => void;
  toggleFeedbackPanel: () => void;
}

export const useSettingsStore = create<SettingsStore>()(
  persist(
    (set) => ({
      animationSpeed: "normal",
      fontSize: "medium",
      defaultFeedbackView: "timeline",
      notifyOnRunComplete: true,
      notifyOnError: true,
      notifyOnInputRequest: true,
      sidebarCollapsed: false,
      rightPanelCollapsed: false,
      feedbackPanelCollapsed: false,
      forceLayoutMode: "auto",

      setSetting: (key, value) => set({ [key]: value } as any),
      toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
      toggleRightPanel: () => set((s) => ({ rightPanelCollapsed: !s.rightPanelCollapsed })),
      toggleFeedbackPanel: () => set((s) => ({ feedbackPanelCollapsed: !s.feedbackPanelCollapsed })),
    }),
    { name: "agent-world-settings" },
  ),
);
